'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Context$NimbusWeb = require("./Context.bs.js");
var Storage$NimbusWeb = require("../utils/Storage.bs.js");

function defaultValue_001(param) {
  return /* () */0;
}

var defaultValue = /* tuple */[
  undefined,
  defaultValue_001
];

var Token = Context$NimbusWeb.Make({
      defaultValue: defaultValue
    });

function defaultValue_001$1(param) {
  return /* () */0;
}

var defaultValue$1 = /* tuple */[
  undefined,
  defaultValue_001$1
];

var UserType = Context$NimbusWeb.Make({
      defaultValue: defaultValue$1
    });

function AuthContext$Wrap(Props) {
  var children = Props.children;
  var match = React.useState((function () {
          return Storage$NimbusWeb.get(/* Token */0);
        }));
  var match$1 = React.useState((function () {
          return Storage$NimbusWeb.get(/* Type */2);
        }));
  return React.createElement(Token.Provider.make, Curry._3(Token.Provider.makeProps, /* tuple */[
                  match[0],
                  match[1]
                ], React.createElement(UserType.Provider.make, Curry._3(UserType.Provider.makeProps, /* tuple */[
                          match$1[0],
                          match$1[1]
                        ], children, /* () */0)), /* () */0));
}

var Wrap = {
  make: AuthContext$Wrap
};

exports.Token = Token;
exports.UserType = UserType;
exports.Wrap = Wrap;
/* Token Not a pure module */
